import React, { useState, useCallback, useEffect, useContext } from 'react';
import { useForm, watch } from 'react-hook-form';
import { useMutation, useLazyQuery } from '@apollo/client';
import DataState from 'app/src/components/DataState';
import Input from 'app/src/elements/inputs';
import { Button, ButtonGroup } from 'app/src/elements/buttons';
import { View, Text } from 'react-native';
import { UPDATE_SELLER_USER } from '../SellerUsers/queries';
import AuthContext from '../../contexts/AuthContext';
import styled from 'styled-components/native';

const ButtonContainer = styled(View)`
`;

const EditAccount = ({setShowModal}) => {
  const { user, refetchData } = useContext(AuthContext);
  const [submitting, setSubmitting] = useState();
  const [updateUser] = useMutation(UPDATE_SELLER_USER, {
    onCompleted: () => {
      setSubmitting(false);
      setShowModal(false);
      refetchData();
    }
  });

  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  const onSubmit = useCallback(input => {
    if (input.password === input.confirmPassword) {
      setSubmitting(true);
      if(input.password === '') {
        delete input['password'];
      }
      updateUser({ variables: input })
    }
  });

  const { control, handleSubmit, register, watch, setValue, formState: { errors } } = useForm({
    defaultValues: {
      id: user?.id,
      firstName: user?.firstName || '',
      lastName: user?.lastName || '',
      // email: user?.email || '',
      defaultNotificationsEmail: user?.defaultNotificationsEmail || true,
      liveSaleNotificationsEmail: user?.liveSaleNotificationsEmail || true,
      password: '',
      confirmPassword: '',
    }
  });


  const handleNewPasswordChange = (event) => {
    const newPassword = event.target.value;
    setShowConfirmPassword(newPassword !== '');
  }

  useEffect(() => {
    if(!user) return;
    setValue('id', user?.id)
    setValue('firstName', user?.firstName || '');
    setValue('lastName', user?.lastName || '');
    // setValue('email', user?.email || '');
    setValue('defaultNotificationsEmail', user?.defaultNotificationsEmail);
    setValue('liveSaleNotificationsEmail', user?.liveSaleNotificationsEmail);
  }, [user])

  const newPasswordValue = watch('password', '');

  return (
    <View>
      {submitting ?
        DataState.Loading :
        <View>
          {/* <Input.Text
            label="Email:"
            name="email"
            control={control}
            errors={errors}
            id="email"
            {...register("email", {
              required: "Email is required",
              validate: {
                maxLength: (v) =>
                  v.length <= 50 || "The email should have at most 50 characters",
                matchPattern: (v) =>
                  /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) ||
                  "Email address must be a valid address",
              },
            })}
          /> */}
          <Input.Text
            label="First Name:"
            name="firstName"
            control={control}
            errors={errors}
          />
          <Input.Text
            label="Last Name:"
            name="lastName"
            control={control}
            errors={errors}
          />
          <Input.Checkbox
            label="Receive Non-Sale Notifications via Email?"
            name="defaultNotificationsEmail"
            control={control}
            errors={errors}
          />
          <Input.Checkbox
            label="Receive Live Sale Notifications via Email?"
            name="liveSaleNotificationsEmail"
            control={control}
            errors={errors}
          />
          <Input.Text
            label="New Password:"
            name="password"
            control={control}
            errors={errors}
            secureTextEntry={true}
            onChange={handleNewPasswordChange}
            {...register("password", {
              required: false,
            })}
          />
          {newPasswordValue !== '' && (
            <Input.Text
              label="Confirm New Password:"
              name="confirmPassword"
              control={control}
              errors={errors}
              secureTextEntry={true}
              {...register("confirmPassword", {
                required: false,
                validate: (val) => {
                  if (watch('password') != val) {
                    return "Your passwords do no match";
                  }
                },
              })}

            />
          )}

          <ButtonContainer>
            <ButtonGroup>
              <Button label="Update Account" onPress={handleSubmit(onSubmit)} />
            </ButtonGroup>
          </ButtonContainer>
        </View>
      }
    </View>
  )
};

export default EditAccount;
